import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { ApolloProvider } from '@common/hooks';
import apollo from 'works/legacy/lib/graph-ql';
import { ErrorBoundary } from './legacy/lib/sentry';
import { loadIntercom } from 'works/legacy/lib/intercom';
import { AppLayout, AppSidebar, BrowserRouter } from '@common/components';
import { AuthGuard } from 'works/legacy/components/auth-guard';
import { OrganizationOnly } from 'works/legacy/components/auth-guard/organization-only';
import { SupplierOnly } from 'works/legacy/components/auth-guard/supplier-only';
import { PublicRoutes } from '@routes/public/public-routes';
import { SupplierRoutes } from '@routes/supplier/supplier-routes';
import { OrganizationRoutes } from '@routes/organization/organization-routes';
import { InactivityModal } from '@identity/components/inactivity-modal';
import { ChunkVersionController } from './chunk-version-controller';
import { DialogsController } from '@routes/dialogs';
import { SentryMetadataInitializer } from '@identity/components/sentry-metadata-initializer';

export function App() {
  loadIntercom();

  return (
    <React.StrictMode>
      <ErrorBoundary>
        <ApolloProvider client={apollo}>
          <BrowserRouter>
            <ChunkVersionController />
            <PublicRoutes />
            <AuthGuard>
              <SentryMetadataInitializer />
              <DialogsController />
              <AppLayout sidebar={<AppSidebar />}>
                <OrganizationOnly>
                  <OrganizationRoutes />
                </OrganizationOnly>
                <SupplierOnly>
                  <SupplierRoutes />
                </SupplierOnly>
              </AppLayout>
              <InactivityModal />
            </AuthGuard>
          </BrowserRouter>
        </ApolloProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
